<button class="button button__underline" (click)="download()">
  Generate excel report
</button>
